<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                        >{{ $t('landingPage.settingFirstView.applicationPeriod') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="timeForm.title"
                            :config.sync="configForm.configFieldTitle"
                            @change="handleShotCodeStyle"
                            @blur="handleValidateField(configForm.configFieldTitle)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.startDate') }} </label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="timeForm.start_date"
                            :config.sync="configForm.configFieldStartDateTime"
                            @change="handleShotCodeStyle"
                            @blur="handleValidateField(configForm.configFieldStartDateTime)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.endDate') }} </label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="timeForm.end_date"
                            :config.sync="configForm.configFieldEndDateTime"
                            @change="handleShotCodeStyle"
                            @blur="handleValidateField(configForm.configFieldEndDateTime)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.selectedStyle') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in listStyleTime" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="timeForm.style"
                                    :name="`application_period-style`"
                                    :id="`application_period-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>

                        <div class="mt-3">
                            <Editor
                                v-if="isVisibleEditor"
                                :id="`editorTimeApplication`"
                                :isBackgroundImageEditor="false"
                                :model.sync="timeForm.html_content"
                                :modelEvents="`change keydown blur focus paste`"
                                :configInit="configEditor"
                                @init="onEditorInit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { validateEndDate, onHandleChangeTemp, mapImageDefault } from '../../handlers';
import { tranferShortCode, transferHTMLToShortcode } from '@/utils/format';
import { LIST_STYLE_TIME } from '../../styles';
import { cloneDeep } from 'lodash';

import Editor from '@/components/Editor/main.vue';

export default {
    name: 'SettingTimeApplication',
    components: {
        InputText,
        InputRadio,
        Editor
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage', 'idxRefreshCampaign'])
        })
    },
    data() {
        return {
            timeForm: cloneDeep(this.dataForm),
            listStyleTime: mapImageDefault(LIST_STYLE_TIME),
            objEditor: null,
            configEditor: {
                height: 600,
                content_style: ''
            },
            isVisibleEditor: false
        };
    },
    methods: {
        handleValidateField(configField, action = []) {
            validateField(configField);
            if (action.includes('compare-date')) {
                validateEndDate(this.configForm[action[1]], this.configForm[action[2]]);
            }
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        },

        handleShotCodeStyle(type = null) {
            let { title, start_date, end_date, style } = this.timeForm;
            if (type === 'select') {
                this.timeForm.html_content = '';
                this.objEditor.setContent('');
                this.configEditor.content_style = style?.cssStyle;
            }
            let contentShotCode = '';
            const replacements = {
                タイトル: title ?? '',
                開始: start_date ?? '',
                終了: end_date ?? ''
            };
            if (this.timeForm.html_content) {
                const placeholders = {
                    shotTitle: '《タイトル》',
                    shotStartTime: '《開始》',
                    shotEndTime: '《終了》'
                };
                const resultContent = transferHTMLToShortcode(placeholders, this.timeForm.html_content);
                contentShotCode = tranferShortCode(resultContent, replacements);
            } else {
                contentShotCode = tranferShortCode(style?.contents, replacements);
            }
            this.objEditor.setContent(contentShotCode ?? '');
            if (type === 'select') {
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
            }
            this.timeForm.html_content = contentShotCode;
        },

        updateEditorStyle(editor, newCss) {
            const head = editor.contentDocument.head || editor.getDoc().head;
            let styleTag = head.querySelector('#dynamic-editor-style');
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = 'dynamic-editor-style';
                head.appendChild(styleTag);
            }
            styleTag.innerHTML = newCss;
        },

        onTimeOpenEditor() {
            setTimeout(() => {
                this.isVisibleEditor = true;
                this.configEditor.content_style = this.timeForm.style?.cssStyle;
            }, 300);
        }
    },
    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                let { style } = this.timeForm;
                if (style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.timeForm, this.listStyleTime);
                if (checkTem && this.objEditor) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        dataForm: {
            handler: function (newDataForm) {
                this.timeForm = newDataForm;
            },
            deep: true
        },

        timeForm: {
            handler: function (newTimeForm) {
                this.$emit('update:dataForm', newTimeForm);
            },
            deep: true
        },

        idxRefreshCampaign: {
            handler: function () {
                this.handleShotCodeStyle();
            },
            deep: true
        }
    },
    mounted() {
        this.onTimeOpenEditor();
    }
};
</script>

<style lang="scss" scoped></style>
